module.exports = __webpack_public_path__ + "static/media/SI.f1310cea.png";